export default {
  DISCLAIMER_SMALL: {
    color: '#999',
    fontSize: 10,
    lineHeight: '1.5em'
  }
};